<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button size="mini" type="primary" plain @click="onExport" v-if="!isMB">导出</el-button>
        <template v-if="$permission.canWrite()">
          <el-button size="mini" type="primary" @click="create">添加</el-button>
          <el-button size="mini" type="danger" @click="delRows">删除</el-button>
        </template>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="60">
          <template slot-scope="{row}" v-if="row.AddTeacherId==nowTid">
            <el-button type="text" @click="editById(row.MedicalId)" size="medium" icon="el-icon-edit-outline" title="编辑"></el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/st/medical/list";
import editDialog from "@/components/st/medical/editDialog";

export default {
  name: "medical",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      nowTid: this.$store.state.user.teacherId,
    };
  },
  methods: {
    onExport() {
      this.$refs.list.onExport();
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.MedicalId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>